import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client';
import { RichText } from 'prismic-reactjs';
import './ProfessionalActivities.css';

const ProfessionalActivities = ({client}) => {
    const [doc, setDoc] = useState([]);
    const [other, setOther] = useState([]);
    const [type, setType] = useState('INFORMS');
    const [otherType, setOtherType] = useState('Editorial Activities');
    const [hover, setHover] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'professional_organization_activities'), {orderings : '[my.professional_organization_activities.position]'}
            )
            if (response) {
                setDoc(response.results);
            }
            }
            fetchData()
    }, [client]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'other_activities'), {orderings : '[my.other_activities.position]'}
            )
            if (response) {
                setOther(response.results);
            }   
            }
            fetchData()
    }, [client]);
    
    if(doc.length > 0 && other.length > 0){
        return (
            <div className="Professional-Activities">
                <h2 className="borderless">Professional Organization Activities</h2>
                <div className="button-container-wrapper">
                <div className="button-container">
                        {doc.map(d => 
                        <div key={d.data.organization} className="round-button-wrapper" onClick={() => setType(d.data.organization)}>
                            <div onMouseEnter={_ => setHover(d.data.organization)} onMouseLeave={_ => setHover('')} className={type === d.data.organization || hover === d.data.organization ? "image image-selected" : "image"}>{d.data.organization}</div>
                            <div className={type === d.data.organization || hover === d.data.organization ? "round-button round-button-selected" : "round-button"}></div>
                            </div>)}
                    </div>
                    <div className="details">
                        {doc.filter(function(d){return d.data.organization === type}).map(d => 
                        (<div key={d.data.organization}><h3>{d.data.organization} - {d.data.title}</h3>
                            <RichText render={d.data.details} /></div>))}
                    </div>
                </div>
                <h2>Other Activities</h2>
                <div className="button-container-wrapper">
                <div className="button-container">
                        {other.map(d => 
                        <div key={d.data.title} className="round-button-wrapper" onClick={() => setOtherType(d.data.title)}>
                            <div onMouseEnter={_ => setHover(d.data.title)} onMouseLeave={_ => setHover('')} className={otherType === d.data.title || hover === d.data.title ? "image image-cover image-cover-selected" : "image image-cover"}>{d.data.title}</div>
                            <div className={otherType === d.data.title || hover === d.data.title ? "round-button round-button-selected" : "round-button"}></div>
                            </div>)}
                    </div>
                    <div className="details">
                        {other.filter(function(d){return d.data.title === otherType}).map(d => 
                        (<div key={d.data.title}><h3>{d.data.title}</h3>
                            <RichText render={d.data.details} /></div>))}
                        <div className="image-grid" style={{paddingTop: "2em", paddingBottom: "1em"}}>
                        {other.filter(function(d){return d.data.title === otherType}).flatMap(d => d.data.image_grid).map(i => (
                            <div className="image-grid-image" style={{textAlign: 'center'}} key={i.image1.url}>
                                <div><img alt="Organization" style={{width: "200px"}} src={i.image1.url} /></div>
                                {i.title1.length > 0 && <div style={{width: "250px"}}>{i.title1[0].text}</div>}
                            </div>
                        ))}
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    } else {
        return <div className="Professional-Activities">Loading...</div>
    }
};

export default ProfessionalActivities;